export const uploadTaxDocTabData = [
  "Personal Docs",
  "General Business",
  // "Rental Property",
  // "Truck Driver",
];
